module.exports = "/_next/static/images/th-62f0033c55e17aaa3153e000c121ab13.svg";